import React from 'react'
import { Header, Planner } from 'ywana-core8'
import './page.css'

const Page = (props) => {

    const lanes = [
        { id: "project1", label: "Sprinter" },
        { id: "lane2", label: "Studios" },
        { id: "lane3", label: "Family" },
        { id: "lane3", label: "Kiosk" },
    ]

    const events = []

    return (
        <>
            <Header title="Calendar" />
            <main>
                <Planner title="Planner 1" lanes={lanes} events={events} navigation={true} >

                </Planner>
            </main>
        </>
    )
}
            
export default Page